import React, { memo, useCallback } from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import { useValueRef } from '../../../../../../hooks/useValueRef';
import styles from './index.module.scss';

const MemoizedBtn = memo(Btn);

const OptionButtonGroup = ({
  className,
  value: currentValue,
  onChange,
  onOptionClick,
  options,
  multiple = false,
  withCheckIcon = false,
  keyPropName = 'value',
}) => {
  const propsRef = useValueRef({
    currentValue,
    onChange,
    multiple,
    onOptionClick,
  });

  const handleClick = useCallback(
    ({ value, selected }) => {
      const { currentValue, onChange, multiple, onOptionClick } =
        propsRef.current;
      onChange(getNewValue({ currentValue, value, multiple, selected }));

      if (typeof onOptionClick === 'function') {
        onOptionClick({ value, selected });
      }
    },
    [propsRef]
  );

  return (
    <div className={cn(styles.root, className)}>
      {options.map((props) => {
        const { value, label } = props;

        const selected = multiple
          ? currentValue?.includes(value)
          : currentValue === value;

        return (
          <MemoizedBtn
            key={props[keyPropName]}
            value={value}
            label={label}
            selected={selected}
            onClick={handleClick}
            withIcon={withCheckIcon}
          />
        );
      })}
    </div>
  );
};

export default OptionButtonGroup;

function Btn({ value, label, selected = false, onClick, withIcon }) {
  return (
    <Button
      onClick={() => onClick({ value, selected: !selected })}
      className={cn(styles.btn, { [styles.selected]: selected })}
    >
      {selected && withIcon && <Icon type="check" style={{ height: '14px' }} />}
      {label}
    </Button>
  );
}

function getNewValue({ currentValue, value, multiple, selected }) {
  if (multiple) {
    const list = currentValue || [];
    return selected ? [...list, value] : list.filter((v) => v !== value);
  }
  return selected ? value : undefined;
}
